import { useQuery } from '@tanstack/react-query'
import { fetchOutstandingDocuments } from '../services/outstand_service';

const GetOutstandingDocuments = (page = 1, pageSize = 10) => {
 const getOutstandingDocuments = useQuery({
    queryKey:['outstanding_documents', page, pageSize],
    queryFn: () => fetchOutstandingDocuments(page, pageSize)
 })
 return getOutstandingDocuments;
}

export default GetOutstandingDocuments